import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

console.log("Tenant ID:", process.env.GATSBY_MSAL_TENANT_ID);
// Base config (SSR-safe – no window access here)
const msalConfig = {
  auth: {
    clientId: process.env.GATSBY_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.GATSBY_MSAL_TENANT_ID}`,
    knownAuthorities: ["login.microsoftonline.com"],
    // redirectUri and postLogoutRedirectUri will be set dynamically below
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

// Create the instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Function to get the current redirect URI (only call this client-side!)
export const getRedirectUri = () => {
  if (typeof window !== "undefined") {
    return window.location.origin + "/";
  }
  // Fallback during SSR (can be any valid registered URI, but won't be used)
  return "http://localhost:8000/auth/callback";
};

// Same for post-logout
export const getPostLogoutRedirectUri = () => {
  if (typeof window !== "undefined") {
    return window.location.origin + "/";
  }
  return "http://localhost:8000/auth/callback";
};

// Login request scopes
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};